import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  REGEX_PASSWORD,
  REGEX_SPACE,
} from 'app/features/authentication/constants/regex';
import Field from 'app/features/authentication/components/Field';
import S from 'app/features/authentication/components/PasswordField.styled';
import noop from 'app/libs/noop';
import CallToAction from 'app/components/layout/CallToAction.styled';
import { PASSWORD } from 'app/features/authentication/constants/inputNames';

const isValidPassword = password => REGEX_PASSWORD.test(password);
const containsSpace = password => REGEX_SPACE.test(password);

const PasswordField = ({
  floatingTextKey,
  errorTextKey,
  passwordWithSpaceTextKey,
  onPasswordChange,
  testId,
}) => {
  const [isInputPopulated, setInputPopulation] = useState(false);
  const [isPasswordVisible, setIsVisible] = useState(false);
  const inputType = isPasswordVisible ? 'text' : 'password';
  const buttonText = isPasswordVisible
    ? 'authentication_password_hide'
    : 'authentication_password_show';

  return (
    <Field
      as={S.PasswordField}
      name={PASSWORD}
      type={inputType}
      errorTextKey={errorTextKey}
      floatingTextKey={floatingTextKey}
      passwordWithSpaceTextKey={passwordWithSpaceTextKey}
      isValid={isValidPassword}
      containsSpace={containsSpace}
      onValueChange={val => {
        setInputPopulation(Boolean(val));
        onPasswordChange(val);
      }}
      testId={testId}
    >
      {isFocused =>
        (isFocused || isInputPopulated) && (
          <CallToAction
            data-t="auth-form-password-field-toggle-show-hide"
            size="s"
            as={S.PasswordField.Button}
            tabIndex="-1"
            onMouseDown={e => {
              e.preventDefault();
              setIsVisible(!isPasswordVisible);
            }}
          >
            <FormattedMessage id={buttonText} />
          </CallToAction>
        )
      }
    </Field>
  );
};

PasswordField.propTypes = {
  floatingTextKey: PropTypes.string.isRequired,
  errorTextKey: PropTypes.string.isRequired,
  passwordWithSpaceTextKey: PropTypes.string.isRequired,
  onPasswordChange: PropTypes.func,
  testId: PropTypes.string.isRequired,
};

PasswordField.defaultProps = {
  onPasswordChange: noop,
};

export default PasswordField;
